export default function getDateObjectFromDateStringOrDateObject(date: string | Date | null): Date | null {
  if ('string' === typeof date) {
    const parts = date.split('-');
    date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (!isNaN(date.getTime())) {
      return date;
    }
  } else if (null !== date && !isNaN(date.getTime())) {
    return date;
  }

  return null;
}